/* BIOMPLEX · Analyse: „Deine Formel entsteht“ und Auswertungsmoment · 02.11.2026
   Ergänzt assets/bx-analyse.js nur in der Darstellung. Liest S, GOALS; verändert keine Logik. */
(function () {
  if (window.__bxFormel) return; window.__bxFormel = 1;
  var ERN = { alles: "Ohne Einschränkung", pesc: "Kein Fleisch, aber Fisch", vegetarisch: "Vegetarisch", vegan: "Vegan" };
  var AUS = { welcome: 1, consent: 1, ausschluss: 1, left: 1, result: 1, laden: 1 };
  function st() { try { return S; } catch (e) { return null; } }
  function gl(g) { try { return (GOALS[g] && GOALS[g].label) || g; } catch (e) { return g; } }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function fortschritt() {
    var b = document.querySelectorAll("#bxq-abschnitte b"); if (!b.length) return 0;
    var t = 0; for (var i = 0; i < b.length; i++) t += parseFloat(b[i].style.width) || 0;
    return t / (b.length * 100);
  }
  function dots(f) {
    var on = Math.max(1, Math.round(f * 8)), h = "";
    for (var i = 0; i < 8; i++) h += '<i class="' + (i < on ? "an" : "") + '"></i>';
    return h;
  }
  var el = document.createElement("aside");
  el.className = "bxf"; el.setAttribute("aria-hidden", "true");
  var last = "";
  function upd() {
    var s = st(); if (!s) return;
    var scr = s.screen, th = (s.tapped || []).slice(0, 4);
    var zeig = !AUS[scr] && th.length > 0;
    document.documentElement.classList.toggle("bxf-an", zeig);
    document.documentElement.classList.toggle("bxf-laden", scr === "laden");
    if (scr === "laden") laden(s);
    /* Name und Auswertung sind der letzte Schritt: Fortschritt voll */
    if (scr === "name" || scr === "laden") {
      var bb = document.querySelectorAll("#bxq-abschnitte b");
      for (var j = 0; j < bb.length; j++) bb[j].style.width = "100%";
    }
    if (scr === "name") namensfeld();
    if (!zeig) { if (el.parentNode) el.parentNode.removeChild(el); return; }
    var nm = (s.name || "").trim();
    var ern = s.ernaehrung ? (ERN[s.ernaehrung] || s.ernaehrung) : "";
    var html =
      '<div class="bxf__kopf"><span class="bxf__eye">Deine Formel</span><span class="bxf__nr">Nº&nbsp;<em>··</em></span></div>' +
      '<p class="bxf__fuer">' + (nm ? "für <b>" + esc(nm) + "</b>" : "entsteht aus Deinen Antworten") + "</p>" +
      '<dl class="bxf__z"><div><dt>Themen</dt><dd>' + th.map(function (g) { return esc(gl(g)); }).join(" · ") + "</dd></div>" +
      "<div><dt>Ernährung</dt><dd>" + (ern ? esc(ern) : "<span>folgt</span>") + "</dd></div></dl>" +
      '<div class="bxf__slots"><span class="bxf__s bxf__s--m"><i></i>Morgens · 1/2</span><span class="bxf__s bxf__s--e"><i></i>Abends · 2/2</span></div>' +
      '<div class="bxf__dots">' + dots(fortschritt()) + "</div>";
    if (html !== last) { el.innerHTML = html; last = html; }
    var mobil = window.matchMedia("(max-width: 989px)").matches;
    var ziel = mobil ? document.querySelector(".bxq main.wrap") : document.getElementById("bxq-bild");
    if (!ziel) return;
    el.classList.toggle("bxf--leiste", mobil);
    if (mobil) { if (el.parentNode !== ziel || ziel.firstChild !== el) ziel.insertBefore(el, ziel.firstChild); }
    else if (el.parentNode !== ziel) ziel.appendChild(el);
  }
  /* Namensfeld: Tastatur mit „Los“, großer Anfangsbuchstabe; am Rechner direkt im Feld */
  function namensfeld() {
    var f = document.getElementById("vorname"); if (!f || f.dataset.bxf) return;
    f.dataset.bxf = "1";
    f.setAttribute("enterkeyhint", "go"); f.setAttribute("autocapitalize", "words");
    f.setAttribute("autocorrect", "off"); f.setAttribute("spellcheck", "false");
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    /* Handy: bei offener Tastatur den Knopf „Zum Ergebnis“ mit ins Bild holen */
    f.addEventListener("focus", function () {
      setTimeout(function () { var k = document.querySelector("#app .leiste .btn"); if (k) try { k.scrollIntoView({ block: "end", behavior: "smooth" }); } catch (e) {} }, 350);
    });
  }
  /* Auswertung: zwei Etiketten entstehen, bevor das Ergebnis öffnet */
  function laden(s) {
    var sec = document.querySelector("#app .frage"); if (!sec || sec.querySelector(".bxf-duo")) return;
    var nm = (s.name || "").trim();
    var d = document.createElement("div"); d.className = "bxf-duo";
    d.innerHTML = ["m", "e"].map(function (k) {
      return '<div class="bxf-et bxf-et--' + k + '"><span class="bxf-et__eye">Deine Formel</span>' +
        '<span class="bxf-et__nr">Nº <em>··</em></span><span class="bxf-et__z">' + (k === "m" ? "Morgens · 1/2" : "Abends · 2/2") + "</span>" +
        (nm ? '<span class="bxf-et__f">für ' + esc(nm) + "</span>" : "") + '<span class="bxf-et__b"><i></i><i></i></span></div>';
    }).join("");
    sec.appendChild(d);
  }
  function wrap() {
  var orig = window.bxqSchritt;
  if (typeof orig === "function" && !orig.__bxf) {
    window.bxqSchritt = function (i, n) {
      var s = st();
      if (s && s.screen === "laden" && i === n && !window.__bxfFertig) {
        window.__bxfFertig = 1;
        var li = document.querySelectorAll("#schritte li"); if (li.length) li[li.length - 1].classList.add("ok");
        var d = document.querySelector(".bxf-duo"); if (d) d.classList.add("fertig");
        setTimeout(function () { window.__bxfFertig = 0; orig(i, n); }, 1500);
        return;
      }
      return orig(i, n);
    };
    window.bxqSchritt.__bxf = 1;
  }
  }
  function start() {
    wrap();
    var app = document.getElementById("app"); if (!app) return;
    new MutationObserver(function () { setTimeout(upd, 0); }).observe(app, { childList: true });
    document.addEventListener("input", function (e) { if (e.target && e.target.id === "vorname") setTimeout(upd, 0); });
    window.addEventListener("resize", function () { last = ""; upd(); });
    upd();
  }
  if (document.readyState === "complete") start(); else document.addEventListener("DOMContentLoaded", start);
})();
